// extracted by mini-css-extract-plugin
export var cardHeader = "_uh-0";
export var reorderHandle = "_uh-3";
export var titleArea = "_uh-1";
export var titleAreaWithHandle = "_uh-2";